export default [
  {
    title: 'Tableau de bord',
    route: 'dashboard',
    icon: 'HomeIcon',
  },
  {
    title: 'Mes Factures',
    route: 'driver-invoice-list',
    icon: 'FileTextIcon',
  },
]
